export default __webpack_public_path__ + "static/media/tp_logo_animated_orange.53d4d59a.gif";